import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarContasContabeisRegraProvisionamentoDashboard(api) {
    let parametros = {
      operacao: 'buscarContasContabeisRegraProvisionamentoDashboard'
    }

    let retorno = {};
    await api.santriGET('/rest/contaContabil', parametros, 40, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarContasContabeisSaldoDiferenteNaturezaDashboard(api) {
    let parametros = {
      operacao: 'buscarContasContabeisSaldoDiferenteNaturezaDashboard'
    }

    let retorno = {};
    await api.santriGET('/rest/contaContabil', parametros, 40, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RContaContabil.js